export default __webpack_public_path__ + "static/media/instagramWallMontparnasse.2487f748.jpg";